import { FC } from 'react';
import { useSelector } from 'react-redux';
import UserAvatar, { UserAvatarProps } from 'components/UserAvatar';

interface AuthUserAvatarProps {
  size?: UserAvatarProps['size'];
}

const AuthUserAvatar: FC<AuthUserAvatarProps> = ({ size }) => {
  const currentUser = useSelector((store: any) => store.auth.user);

  return <UserAvatar user={currentUser} size={size} />;
};

export default AuthUserAvatar;
